import createModule from "../createModule"
import view from "./view"
import { Creators as ProfileCreators } from "model/profileModal"
import { getSortedContributors, getSortedGroupContributors, getSelectedGroupValue, getAvailableRollups, getContributorsSummaryText, getExcelData, getSelectedGroupSiblings, getSelectedGroup, getCurrentGrouping } from "./selectors"
import { getGroupsDropdownColumns } from "./selectors/group"
import { generateClassificationQueryForContributors } from "helpers/classification"
import { getIsOpPro } from "modules/account-root/selectors"
import { getQueryGroupBy } from "helpers/rollups"
import { convertPositionSetType } from "helpers/compositeSecurities"

export default createModule({
  view,
  required: ["positionSetId", "positionSetType", "modelId", "account"],
  data: [{
    resource: "compositeForecastContributors",
    as: null,
    url: ({ positionSetId, positionSetType, modelId, forecastId, selectedDate, segment, classifications }) => {
      if (!selectedDate || !forecastId) { return null }
      return {
        id: `compositeForecastContributors-${modelId}${positionSetId}${positionSetType}${forecastId}${selectedDate}${JSON.stringify(segment)}`,
        query: `query ($modelId: String!, $positionSet: PositionSetInput!, $forecastId: ShortId!, $date: Date!) {
            model (id: $modelId) {
              simulation (positionSet: $positionSet, from: $date, to: $date, interval: END_DATE) {
                forecastContributors (on: $date, forecastId: $forecastId) {
                  date
                  contributors{
                    assetClass
                    assetSubclass
                    id
                    country
                    currency
                    ${generateClassificationQueryForContributors("GICS", classifications)}
                    description
                    bloombergTicker
                    percentEquity
                    weightedExpectedReturn
                    modelProviderId
                  }
                }
              }
            }
          }`,
        variables: {
          modelId,
          positionSet: {
            id: positionSetId,
            type: convertPositionSetType(positionSetType),
            segment,
          },
          forecastId,
          date: selectedDate,
        },
      }
    },
  }, {
    resource: "compositeGroupedForecastContributors",
    as: null,
    url: ({ positionSetId, positionSetType, modelId, forecastId, selectedDate, currentGrouping, segment, classifications }) => {
      if (!currentGrouping) {
        return null
      }

      const queryGroupBy = getQueryGroupBy(currentGrouping)

      return {
        id: `groupedForecastContributors-${modelId}${positionSetId}${positionSetType}${selectedDate}${JSON.stringify(queryGroupBy)}${JSON.stringify(segment)}`,
        query: `query ($modelId: String!, $positionSet: PositionSetInput!, $forecastId: ShortId!, $date: Date!, $groupBy: ContributorGroupType!, $groupById: String, $tier: String) {
            model (id: $modelId) {
              simulation (positionSet: $positionSet, from: $date, to: $date, interval: END_DATE) {
                groupedForecastContributors (on: $date, forecastId: $forecastId, groupBy: $groupBy, groupById: $groupById, classificationTier: $tier) {
                  date
                  groupedContributors {
                    name
                    id
                    totalPercentEquity
                    totalExpectedReturn
                    contributors {
                      id
                      assetClass
                      country
                      ${generateClassificationQueryForContributors("GICS", classifications)}
                      currency
                      description
                      percentEquity
                      weightedExpectedReturn
                      bloombergTicker
                      modelProviderId
                    }
                  }
                }
              }
            }
          }`,
        variables: {
          modelId,
          positionSet: {
            id: positionSetId,
            type: convertPositionSetType(positionSetType),
            segment,
          },
          forecastId,
          date: selectedDate,
          ...queryGroupBy,
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    data: getSortedContributors(state, props),
    groupedData: getSortedGroupContributors(state, props),
    availableRollups: getAvailableRollups(state, props),
    currentGrouping: getCurrentGrouping(state, props),
    contributorsSummaryText: getContributorsSummaryText(state, props),
    excelData: getExcelData(state, props),
    selectedGroup: getSelectedGroup(state, props),
    selectedGroupValue: getSelectedGroupValue(state, props),
    isOpPro: getIsOpPro(state),
    selectedGroupSiblings: getSelectedGroupSiblings(state, props),
    groupsDropdownColumns: getGroupsDropdownColumns(state, props),
  }),
  actions: {
    openSecurityProfile: ProfileCreators.openSecurityProfile,
    openFactorProfile: ProfileCreators.openFactorProfile,
  },
})
